import React from 'react';
import type { AuthSession, AuthUser } from '@supabase/supabase-js';
import type { AuthProvider } from '../utils/auth';

export interface AuthContextValue {
  initialized: boolean;
  isAuthenticated: boolean;
  session: AuthSession | null;
  user: AuthUser | null;
  signInWithProvider: (provider: AuthProvider, nextPath?: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = React.createContext<AuthContextValue | undefined>(undefined);
